import React, { useRef } from 'react';
import { LinkWithGAPromoClick } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { lowerBoundsBreakpoints, strictBreakpoints } from 'common/styles/breakpoints';
import { SEASON_START_HOUSE_CDN_PATH } from '../../house-page-constants';
import {
  housePageDistribution,
  housePageDistributionBanner,
} from './house-page-distribution-styles';

type HousePageDistributionProps = {
  elementBlock: string;
}

export const HousePageDistribution: React.FC<HousePageDistributionProps> = ({ elementBlock }) => {
  const refs = useRef<HTMLAnchorElement[]>([]);
  const promotions = [
    {
      name: elementBlock,
      creative: 'Обновим ванную с выгодой',
      position: '1',
    },
    {
      name: elementBlock,
      creative: 'Обновим кухню с выгодой',
      position: '2',
    },
    {
      name: elementBlock,
      creative: 'Проектирование систем хранения под ключ',
      position: '3',
    },
  ];

  usePromoViewEvent(refs, elementBlock, promotions);

  return (
    <div className={housePageDistribution}>
      <LinkWithGAPromoClick
        bannerRefs={refs}
        className={housePageDistributionBanner}
        position={0}
        promotion={promotions[0]}
        elementBlock={elementBlock}
        href="/promo/pora-pora-dom-vannaya/"
        title="Обновим ванную с выгодой"
      >
        <picture>
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/bathroom-ld.jpg/bathroom-ld.jpg`} media={lowerBoundsBreakpoints['--from-desktop']} />
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/bathroom-t.jpg/bathroom-t.jpg`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Изображение баннера для ванной"
            src={`${SEASON_START_HOUSE_CDN_PATH}/distribution/bathroom-m.jpg/bathroom-m.jpg`}
          />
        </picture>
      </LinkWithGAPromoClick>
      <LinkWithGAPromoClick
        bannerRefs={refs}
        className={housePageDistributionBanner}
        position={1}
        promotion={promotions[1]}
        elementBlock={elementBlock}
        href="/promo/pora-pora-dom-kuhnya/"
        title="Обновим кухню с выгодой"
      >
        <picture>
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/kitchen-ld.jpg/kitchen-ld.jpg`} media={lowerBoundsBreakpoints['--from-desktop']} />
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/kitchen-t.jpg/kitchen-t.jpg`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Изображение баннера для кухни"
            src={`${SEASON_START_HOUSE_CDN_PATH}/distribution/kitchen-m.jpg/kitchen-m.jpg`}
          />
        </picture>
      </LinkWithGAPromoClick>
      <LinkWithGAPromoClick
        bannerRefs={refs}
        className={housePageDistributionBanner}
        position={2}
        promotion={promotions[2]}
        elementBlock={elementBlock}
        href="/uslugi/proektirovanie-i-dizayn/proektirovanie-sistem-hraneniya/"
        title="Проектирование систем хранения под ключ"
      >
        <picture>
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/wardrobe-ld.jpg/wardrobe-ld.jpg`} media={lowerBoundsBreakpoints['--from-desktop']} />
          <source srcSet={`${SEASON_START_HOUSE_CDN_PATH}/distribution/wardrobe-t.jpg/wardrobe-t.jpg`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Изображение баннера для гардеробной"
            src={`${SEASON_START_HOUSE_CDN_PATH}/distribution/wardrobe-m.jpg/wardrobe-m.jpg`}
          />
        </picture>
      </LinkWithGAPromoClick>
    </div>
  );
}
